import styled from "styled-components";
import Text from "../../../styles/Text";
import {Link} from "react-router-dom";

export const FacilitadoresContainerList = styled.div`
   width: 100%;
   display: flex;
   flex-direction: column;
   padding: 2em 0;
   border-top: 1px solid grey;
`;

export const Facilitador = styled.div`
   width: 33%;
   display: flex;
   align-items: center;
   justify-content: center;
   margin-bottom: 2em;
   margin-top: 2em;

   & .imgSust {
      width: 260px;
      height: 260px;
      background: #394136;
      border-radius: 50%;
      margin-bottom: 2em;

      & img {
         object-fit: cover;
         width: 100%;
         height: 100%;
         border-radius: 50%;
      }
   }

   @media screen and (max-width: 1600px) {
      & .imgSust {
         width: 180px;
         height: 180px;
         margin-bottom: 1.5em;
      }
   }
`;

export const FacilitadorLink = styled(Link)`
   display: inline-flex;
   flex-direction: column;
   align-items: center;
   justify-content: center;

   & ${Text} {
      font-size: 1.2em;
      font-weight: 400;
   }

   @media screen and (max-width: 1600px) {
      & ${Text} {
         font-size: 1em;
      }
   }

   @media screen and (max-width: 500px) {
      width: 100%;

      & .imgSust {
         width: 80px;
         height: 80px;
      }

      & ${Text} {
         font-size: 0.6em;
         text-algn: center;
         white-space: nowrap;
      }
   }
`;

export const FacilidoresListHead = styled.div`
   widht: 100%;
   padding: 0.5em 0;
   display: flex;
   align-items: center;

   & ${Text} {
      font-weight: 500;
      font-size: 1.47em;
      text-transform: uppercase;
      margin-left: 1em;
   }

   & .titleIcon {
      objet-fit: cover;
      height: 1.8em;
   }

   @media screen and (max-width: 1600px) {
      & .titleIcon {
       height: 1.3em;
      }

      & ${Text} {
         font-size: 1.1em;
      }
   }
   @media screen and (max-width: 1400px) {
      & .titleIcon {
         height: 1.5em;
      }
   }

   @media screen and (max-width: 800px) {
      & ${Text} {
         font-size: 1em;
      }
      & .titleIcon {
         height: 1em;
      }
   }
   @media screen and (max-width: 500px) {
      margin-left: 1.3em;
   }
`;

export const FacilidoresListBody = styled.div`
   display: flex;
   // justify-content: flex-star
   flex-wrap: wrap;
`;
